import { render, staticRenderFns } from "./CouponRegister.vue?vue&type=template&id=ccf89c7e&scoped=true&"
import script from "./CouponRegister.vue?vue&type=script&lang=js&"
export * from "./CouponRegister.vue?vue&type=script&lang=js&"
import style0 from "./CouponRegister.vue?vue&type=style&index=0&id=ccf89c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf89c7e",
  null
  
)

export default component.exports